(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('PortalApp', PortalApp);

	PortalApp.$inject = [ '$resource' ];

	function PortalApp($resource) {
		var resourceUrl = 'api/portal-apps/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();
